<script>
export default {
  props: {
    apiAutomation: Object,
    picker: Boolean
  },

  data: function() {
    return {}
  }
}
</script>

<template>
  <div class="pa-3">
    <v-text-field
      label="Name"
      v-model="apiAutomation.apiAutomationName"
      required
      :disabled="picker"
    >
    </v-text-field>

    <v-text-field
      label="Description"
      v-model="apiAutomation.apiAutomationDescription"
      required
      :disabled="picker"
    >
    </v-text-field>
    <v-text-field
      label="Created on"
      v-model="apiAutomation.createdAtLocal"
      disabled
    />
  </div>
</template>

<style scoped></style>
